export const toggleActivity = (id) => {
  return {
    type: 'TOGGLE_ACTIVITY',
    id,
  };
};



// WEBPACK FOOTER //
// ./src/actions/index.js